<template>
  <div class="form-body">
    <div class="row" v-if="showLogin == true">
      <div class="form-holder">
        <div class="form-content">
          <div class="form-items">
            <span class="logo-lg"><img class="img" src="../assets/img/logo-black.png"></span>
            <div class="container" style="width: 100% !important;">
              <div class="col-md-12">
                <div class="">
                  <div class="box-body">
                    <h4 class="box-title">Email ID not registered!</h4>
                    <img class="img" src="../assets/img/meeting_expired.svg">
                  </div>
                  <div class="">
                    <span>Click here to access Interview as a services module </span>
                    <a style="text-decoration: underline red" class="" @click="gotoIaasLogin()">Goto IaaS</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { BaseURLV3 } from '../shared/classes'
import router from '../router/index'

export default {
  data () {
    return {
      email: '',
      showLogin: false
    }
  },
  created () {
    this.email = this.$route.params.email
    this.getLoginDetails()
  },
  methods: {
    getLoginDetails () {
      var data = {
        email: this.email
      }
      axios
        .post(BaseURLV3 + '/interviewer/ids_old_flow', data)
        .then(response => {
          if (response.data.msg === 'Email not found') {
            this.showLogin = true
          } else {
            localStorage.clear()
            localStorage.setItem('user_email', this.email)
            localStorage.setItem('user__details', JSON.stringify(response.data.data))
            localStorage.setItem('token', JSON.stringify(response.data.token))
            if (response.data.data.user_status === 'Step-1') {
              router.push({ name: 'organization_profile_update' })
            } else if (response.data.data.user_status === 'Step-2') {
              router.push({ name: 'DashboardV3' })
            } else {
              router.push({ name: 'Login_v3' })
            }
          }
        })
    },
    gotoIaasLogin () {
      router.push({ name: 'Login_v3' })
    }
  }
}
</script>

<style scoped>
.passwardcompare {
  margin-top: 9px !important;
}
.img {
    width: 30% !important;
    margin-bottom: 15px;
}
.pwd_info {
  float: left;
  font-size: 12px;
  padding-bottom: 11px;
  color: red;
  margin-top: 0px;
}

.pwd_info_float_right {
  float: right;
  font-size: 12px;
  padding-bottom: 11px;
  color: #5BAD2B;
  /* cursor: pointer; */
  margin-top: -10px;
}

.pading_____zero {
  margin-bottom: 2px !important;
}

.was-validated .form-control:valid,
.form-control.is-valid {
  background-image: none;
}

.was-validated .form-control:invalid,
.form-control.is-invalid {
  background-image: none;
}

.form-holder {
  margin-left: 0px;
}

.login-policy-footer {
  width: 31%;
}

.progressbar {
  height: 5px !important;
  background: #e6e6e6;
}

ul {
  padding: 0px;
}

span.field-icon {
  position: absolute;
  display: inline-block;
  cursor: pointer;
  right: 0.5rem;
  top: 0.7rem;
  z-index: 2;
  margin-top: 7px;
}

.register____user__type {
  color: #000000;
  width: 44%;
  margin-left: 3%;
  margin-right: 3%;
  margin-bottom: 17px !important;
  cursor: pointer;
}

.progress_____round {
  border: 1px solid #5bad2b;
  padding: 9px;
  border-radius: 21px;
  width: 40px;
  height: 40px;
  color: #5bad2b;
  font-weight: bold;
}

.progress_____round____hidden {
  border: 1px solid #bbb4b4;
  padding: 9px;
  border-radius: 21px;
  width: 40px;
  height: 40px;
  color: #bbb4b4;
  font-weight: bold;
}
.form-content {
    width: auto;
}
.box {
  border-top: 0px solid #d2d6de;
  border-radius: 0px;
}
.form-content form {
    margin-bottom: 30px;
    width: 80%;
    margin-left: auto;
    margin-right: auto;
}
.box-header .box-title {
    display: inline-block;
    font-size: 16px;
    margin: 0;
    line-height: 1;
    color:black;
}
.form-content .form-items {
    max-width: 540px;
}
html {
  height: 100% !important;
}
.form-content {
  background-color: #F5F5F5 !important;
}
.form-body {
  background-color: #F5F5F5 !important;
}
input {
  background: #FFFFFF 0% 0% no-repeat padding-box;
    border: 1px solid #DCDCDC;
}
.color-g {
  color: #5bad2b;
}
</style>
